var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H35V9H1V1Z",
    fill: "#90CAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.5H1.94444V8.5H1V9.5ZM3.83333 9.5H5.72222V8.5H3.83333V9.5ZM7.61111 9.5H9.5V8.5H7.61111V9.5ZM11.3889 9.5H13.2778V8.5H11.3889V9.5ZM15.1667 9.5H17.0556V8.5H15.1667V9.5ZM18.9444 9.5H20.8333V8.5H18.9444V9.5ZM22.7222 9.5H24.6111V8.5H22.7222V9.5ZM26.5 9.5H28.3889V8.5H26.5V9.5ZM30.2778 9.5H32.1667V8.5H30.2778V9.5ZM34.0556 9.5H35V8.5H34.0556V9.5Z",
    fill: "#2196F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 4,
    stroke: "#2196F3",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontal);
export default __webpack_public_path__ + "static/media/horizontal.2b672ecb8b1975d167115d0b9dc3c42f.svg";
export { ForwardRef as ReactComponent };